/**
 * 매장 방문 - 휠얼 주문상태
 */
export enum NumWheelOrderStatus {
  /**
   * 예약취소
   */
  // CANCELED_ORDER = 0,
  /**
   * 결제완료
   */
  COMPLETED_PAYMENT = 1,
  /**
   * 주문확정
   */
  CONFIRMED_ORDER = 3,
  /**
   * 작업완료
   */
  COMPLETED_SERVICE = 5,
  /**
   * 구매확정
   */
  CONFIRMED_PURCHASE = 8,
}
